import {
  commonMutationTypes,
  commonPaginationTypes,
  OrderDirection,
  pageInfo,
} from "../../../../../utils/commonQueryTypes";

export enum AtsCompanyOrderField {
  CREATED_AT = "CREATED_AT",
  NAME = "NAME",
  PLACE = "PLACE",
}

export interface GetCompaniesVars extends commonPaginationTypes {
  customerID: number;
  empID: number;
  orderBy: {
    direction: OrderDirection;
    field: AtsCompanyOrderField;
  };
  name: string;
}

export interface AtsCompany {
  id: number;
  name: string;
  address: string;
  place: string;
  state: string;
  pin: string;
  country: string;
  contactPerson: string;
  contactPersonDesign: string;
  contactPersonEmail: string;
  contactPersonMobile: string;
  email: string;
  mobile: string;
  url: string;
  logoFilename: string;
  isActive: string;
  panNo: string;
  gstNo: string;
  tanNo: string;
  vatNo: string;
  oth1No: string;
  oth2No: string;
  latitude: number;
  longitude: number;
  timeZone: string;
  customerID: number;
  enableGst: boolean;
  enableTds: boolean;
  enableTcs: boolean;
  gstState: string;
  mobileNo: string;
  regType: string;
  telephone: string;
  icon: string;
}

export interface AtsCompanyEdge {
  node: AtsCompany;
  cursor: string;
}

interface GetCompaniesData {
  edges: AtsCompanyEdge[];
  pageInfo: pageInfo;
  totalCount: number;
}

export interface GetCompaniesResult {
  GetCompanies: GetCompaniesData;
}

//Mutations

interface CreateAtsCompanyInput {
  name: string;
  address: string;
  place: string;
  state: string;
  pin: string;
  country: string;
  contactPerson: string;
  contactPersonDesign: string;
  contactPersonEmail: string;
  contactPersonMobile: string;
  email: string;
  mobile: string;
  url: string;
  logoFilename: string;
  panNo: string;
  gstNo: string;
  tanNo: string;
  vatNo: string;
  oth1No: string;
  oth2No: string;
  latitude: number;
  longitude: number;
  enableGst: boolean;
  enableTds: boolean;
  enableTcs: boolean;
  regType: string;
  icon: string;
}

interface UpdateAtsCompanyInput {
  name: string;
  address: string;
  place: string;
  state: string;
  pin: string;
  country: string;
  contactPerson: string;
  contactPersonDesign: string;
  contactPersonEmail: string;
  contactPersonMobile: string;
  email: string;
  mobile: string;
  url: string;
  logoFilename: string;
  panNo: string;
  gstNo: string;
  gstState: string;
  tanNo: string;
  vatNo: string;
  oth1No: string;
  oth2No: string;
  latitude: number;
  longitude: number;
  enableGst: boolean;
  enableTds: boolean;
  enableTcs: boolean;
  regType: string;
  icon: string;
}

export interface AddCompanyVar extends commonMutationTypes {
  input: CreateAtsCompanyInput;
  customer_id: number;
}

export interface AddCompanyResult {
  AddCompany: boolean;
}

export interface UpdateCompanyVar extends commonMutationTypes {
  input: UpdateAtsCompanyInput;
  ats_company_id: number;
}

export interface UpdateCompanyResult {
  UpdateCompany: boolean;
}

export interface DeleteCompanyByIdResult {
  DeleteCompany: boolean;
}

export interface DeleteCompanyByIdVars extends commonMutationTypes {
  ats_company_id: number;
}

export enum TableType {
  CUSTOMER = "CUSTOMER",
  COMPANY = "COMPANY",
  SUBSIDIARY = "SUBSIDIARY",
  SITE = "SITE",
  JUNCTION = "JUNCTION",
  ASSET = "ASSET",
  NONE = "NONE",
}

export interface GetNotAllocatedIdsVar {
  token?: string;
  customerID: number;
  companyID: number;
  table: TableType;
  table_id: number;
}

export interface NotAllocateIds {
  companyID: number;
  subsidiaryID: number;
  siteID: number;
  junctionID: number;
}

export interface GetNotAllocatedIdsResult {
  GetNotAllocatedIds: NotAllocateIds;
}

export interface ExportCompanyTemplateData {
  ExportCompanyTemplate: string;
}

export interface ExportCompanyTemplateVars {
  token?: string;
  customerID: number;
}
